const belgianPhoneNumberRegex = /^(?=^.{9,11}$)0\d*-?\d*$/

const isValidPhoneNumber = (phoneNumber: string): boolean =>
  belgianPhoneNumberRegex.test(phoneNumber)

export { isValidPhoneNumber }
